import React from 'react';
import { Route } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import BucketlistsList from './BucketlistsList/BucketlistsList';
import BucketlistEdit from './BucketlistEdit/BucketlistEdit';
import BucketlistCreate from './BucketlistCreate/BucketlistCreate';
import BucketlistDelete from './BucketlistDelete/BucketlistDelete';

const Bucketlists = ({ match }) => {
    return (
        <div className="Bucketlists">
            <ContainerWrapper container="bucketlists">
                <Route exact path={ match.path } component={BucketlistsList} />
                <Route exact path={ `${ match.url }/new` } component={BucketlistCreate} />
                <Route exact path={ `${ match.url }/edit/:bucketlistId` } component={BucketlistEdit} />
                <Route exact path={ `${ match.url }/delete/:bucketlistId` } component={BucketlistDelete} />
            </ContainerWrapper>
        </div>
    );
}

export default Bucketlists;
